
  import { defineComponent } from 'vue';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Tooltip from '@/common/ui/Tooltip.vue';

  export default defineComponent({
    name: 'InputBlock',
    components: { ButtonComponent, Tooltip },
    props: {
      required: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
      tooltipText: {
        type: String,
        default: '',
      },
      mode: {
        type: String,
        default: 'vertical',
        validator(value: string) {
          return ['vertical', 'horizontal'].includes(value);
        },
      },
      isButtonVisible: {
        type: Boolean,
        default: false,
      },
      buttonText: {
        type: String,
        default: 'Группы',
      },
    },
    emits: ['buttonClick'],
    methods: {
      handleButtonClick() {
        this.$emit('buttonClick');
      },
    },
  });
